function initModelDescriptionCarouselDots(scope = document) {
  const featuresContainer = scope.querySelector('.section-product-model-description__features');
  const dotsContainer = scope.querySelector('.section-product-model-description__carousel-dots');
  const dots = scope.querySelectorAll('.section-product-model-description__carousel-dots .carousel-dot');

  if (!featuresContainer || !dotsContainer || dots.length === 0) return;

  const featureCount = featuresContainer.querySelectorAll('.section-product-model-description__feature').length;
  if (featureCount <= 2) {
    dotsContainer.style.setProperty('display', 'none', 'important');
    return;
  }
  dotsContainer.style.removeProperty('display');

  function updateActiveDot() {
    const scrollLeft = featuresContainer.scrollLeft;
    const containerWidth = featuresContainer.offsetWidth;
    const scrollWidth = featuresContainer.scrollWidth;
    const maxScroll = scrollWidth - containerWidth;

    if (maxScroll <= 0) {
      dots.forEach((dot, index) => {
        dot.style.backgroundColor = index === 0 ? 'rgba(0, 0, 0, 0.6)' : 'rgba(0, 0, 0, 0.2)';
      });
      return;
    }

    const scrollPercentage = scrollLeft / maxScroll;
    const activePage = Math.round(scrollPercentage * (dots.length - 1));
    
    dots.forEach((dot, index) => {
      if (index === activePage) {
        dot.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
      } else {
        dot.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
      }
    });
  }

  featuresContainer.addEventListener('scroll', updateActiveDot);
  
  dots.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      const cw = featuresContainer.offsetWidth;
      const sw = featuresContainer.scrollWidth;
      const maxScroll = sw - cw;
      if (maxScroll <= 0 || dots.length <= 1) return;
      const targetScroll = maxScroll * (index / (dots.length - 1));
      featuresContainer.scrollTo({ left: targetScroll, behavior: 'smooth' });
    });
  });

  updateActiveDot();
}

document.addEventListener('DOMContentLoaded', function() {
  initModelDescriptionCarouselDots();
});
